// ============================================
// SUPPORT BUTTON - Floating Destek Butonu
// ============================================

import { useState } from 'react';
import { MessageCircleQuestion, X } from 'lucide-react';
import { SupportModal } from './SupportModal';
import { cn } from '@/utils';
import { useTranslation } from '@crew-at-sea/i18n';

export function SupportButton() {
  const { t } = useTranslation('panel');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  // Kullanıcı butonu geçici olarak gizlemek isterse
  if (isDismissed) {
    return (
      <>
        {/* Küçük geri getir butonu */}
        <button
          onClick={() => setIsDismissed(false)}
          className="fixed bottom-6 right-6 z-40 w-10 h-10 bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full shadow-lg flex items-center justify-center transition-all"
          title={t('support.showButton')}
        >
          <MessageCircleQuestion className="w-5 h-5" />
        </button>

        <SupportModal open={isModalOpen} onOpenChange={setIsModalOpen} />
      </>
    );
  }

  return (
    <>
      {/* Floating Button Container */}
      <div
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Tooltip / Label */}
        <div
          className={cn(
            'bg-white rounded-maritime shadow-lg px-4 py-2.5 flex items-center gap-2 transition-all duration-300',
            isHovered
              ? 'opacity-100 translate-x-0'
              : 'opacity-0 translate-x-4 pointer-events-none'
          )}
        >
          <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
            {t('support.needHelp')}
          </span>
          <button
            onClick={() => setIsDismissed(true)}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            title={t('support.hideButton')}
          >
            <X className="w-3.5 h-3.5 text-gray-400" />
          </button>
        </div>

        {/* Main Button */}
        <button
          onClick={() => setIsModalOpen(true)}
          className={cn(
            'w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300',
            'bg-gradient-to-br from-maritime-500 to-maritime-600 hover:from-maritime-600 hover:to-maritime-700',
            'text-white hover:scale-105 active:scale-95',
            'focus:outline-none focus:ring-4 focus:ring-maritime-300'
          )}
          title={t('support.title')}
        >
          <MessageCircleQuestion className="w-7 h-7" />
        </button>
      </div>

      {/* Modal */}
      <SupportModal open={isModalOpen} onOpenChange={setIsModalOpen} />
    </>
  );
}
